import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import ADIInvoiceModel from "../Data/ADIInvoiceState";
import { InvoiceParams, InvoiceResultModel, MultipleInvoiceResultsModel } from "@NA/Services/ADIInvoiceService";
import { invoiceParams } from "@NA/Handlers/InvoiceHistory/ADIInvoiceHistoryHandler";

const initialState: ADIInvoiceModel = {
    isLoading: false,
    loadInvoiceParameters: invoiceParams,
    invoiceResults: null,
    multipleInvoiceResult: null,
    allLocationsInvoice: false,
    currentInvoiceTab:0,
    isRetrunToInvocie:false,
};

const reducer = {
    "Custom/LoadADIInvoice": (draft: Draft<ADIInvoiceModel>, action: { result: InvoiceParams }) => {
        draft.isLoading = true;
        draft.loadInvoiceParameters = action.result;
    },

    "Custom/UpdateRetrunToInvocie": (draft: Draft<ADIInvoiceModel>, action: { result: boolean }) => {
        draft.isRetrunToInvocie = action.result;;
    },

    "Custom/TabStatusUpdate": (draft: Draft<ADIInvoiceModel>, action: { result: number }) => {
        draft.currentInvoiceTab = action.result;
    },

    "Custom/DispatchCompleteADIInvoice": (
        draft: Draft<ADIInvoiceModel>,
        action: { ADIInvoiceResult: InvoiceResultModel },
    ) => {
        draft.isLoading = false;
        draft.allLocationsInvoice = false;
        draft.invoiceResults = action.ADIInvoiceResult;
    },

    "Custom/LoadADIMultipleInvoice": (draft: Draft<ADIInvoiceModel>, action: { result: InvoiceParams }) => {
        draft.isLoading = true;
        draft.loadInvoiceParameters = invoiceParams;
    },
    "Custom/DispatchCompleteADIMultipleInvoice": (
        draft: Draft<ADIInvoiceModel>,
        action: { ADIMultipleInvoiceResult: MultipleInvoiceResultsModel },
    ) => {
        draft.isLoading = false;
        draft.allLocationsInvoice = true;
        draft.multipleInvoiceResult = action.ADIMultipleInvoiceResult;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
